<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5 9h22a1 1 0 000-2H5a1 1 0 000 2zM27 15H5a1 1 0 000 2h22a1 1 0 000-2zM27 23H5a1 1 0 000 2h22a1 1 0 000-2z"/></svg>